import { RotateCcw, BadgeInfo } from 'lucide-react'
import { Button } from '@/src/renderer/components/ui/Button'
import './SettingsResetCard.scss'

interface SettingsResetCardProps {
  /** Body text — usually a single sentence reassuring the user. */
  description: string
  /** Reset-button label. */
  buttonLabel: string
  /** Click handler. Wire to the page-specific reset logic when ready. */
  onReset?: () => void
  /** When true, the button is disabled. Defaults to enabled. */
  disabled?: boolean
}

/**
 * Muted info-card with a reset CTA. Rendered at the bottom of a Settings
 * page to give the user a calm "you can always undo" affordance.
 */
export function SettingsResetCard({
  description,
  buttonLabel,
  onReset,
  disabled,
}: SettingsResetCardProps) {
  return (
    <div className="settings-reset-card">
      <BadgeInfo className="settings-reset-card__icon" size={24} aria-hidden="true" />
      <p className="settings-reset-card__text">{description}</p>
      <Button
        variant="outline"
        size="small"
        icon={<RotateCcw size={16} />}
        onClick={onReset}
        disabled={disabled}
      >
        {buttonLabel}
      </Button>
    </div>
  )
}
